import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BulkQrCodeComponent } from 'src/app/popups/bulk-qr-code/bulk-qr-code.component';
import { BulkSerialNumbersComponent } from 'src/app/popups/bulk-serial-numbers/bulk-serial-numbers.component';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BarCodeCategory, KeyValueSet, LocalService, Status, TriggeredEvent, Wrappers10 } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';
import { ConfigSerialNumbersComponent } from '../../popups/config-serial-numbers/config-serial-numbers.component';

@Component({
  selector: 'app-serial-numbers',
  templateUrl: './serial-numbers.component.html',
  styleUrls: ['./serial-numbers.component.scss']
})
export class SerialNumbersComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["serial_num", "paging"]; productId: string = ''; ctryCode: string = ''; statuses: KeyValueSet[];
  source: Wrappers10; pagingCounts: KeyValueSet[] = [{ key: "20", value: "20" } as KeyValueSet, { key: "50", value: "50" } as KeyValueSet, { key: "100", value: "100" } as KeyValueSet, { key: "200", value: "200" } as KeyValueSet]; selectedPageCount = '20';
  businessId = ''; maxBodyHeight = 0; purchaseEntryDetailId: string = '0';
  constructor(public localService: LocalService, private router: Router, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private productManagementService: ProductManagementService, private route: ActivatedRoute, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
      this.ctryCode = routeParams.ctryCode;
      this.productId = routeParams.productId;
      this.businessId = routeParams.businessId;
      this.purchaseEntryDetailId = routeParams.purchaseEntryDetailId;
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (!this.statuses) {
      this.productManagementService.getSerialNumbersInitialization(this.productId, this.purchaseEntryDetailId).subscribe(result => {
        this.statuses = result.statuses;
        this.source = result.items;
      });
    } else {
      this.source.paging.dataPerPage = parseInt(this.selectedPageCount);
      this.productManagementService.getSerialNumbers(this.productId, this.purchaseEntryDetailId, this.source.paging).subscribe(result => {
        this.source = result;
      });
    }
  }

  onGenerateBarCode(strValue: string, displayValue: string) {
    // const modalRef = this.modalService.open(BarcodeGeneratorComponent);
    // modalRef.componentInstance.productId = this.productId;
    // modalRef.componentInstance.businessId = this.businessId;
    // modalRef.componentInstance.categoryCode = BarCodeCategory.SerialNumber;
    // modalRef.componentInstance.value = strValue;
    // modalRef.componentInstance.displayValue = displayValue;
    // modalRef.componentInstance.countryCode = this.ctryCode;
    // modalRef.componentInstance.isQuantityShow = false;
  }

  onPrint() {
    let valuesDisplayValues: KeyValueSet[] = [];
    this.source.items.forEach(item => {
      valuesDisplayValues.push({ key: item.key, value: item.v2 } as KeyValueSet);
    });
    if (valuesDisplayValues.length > 0) {
      const modalRef = this.modalService.open(BulkQrCodeComponent);
      modalRef.componentInstance.countryCode = this.ctryCode;
      modalRef.componentInstance.categoryCode = BarCodeCategory.SerialNumber;
      modalRef.componentInstance.productId = this.productId;
      modalRef.componentInstance.businessId = this.businessId;
      modalRef.componentInstance.valuesDisplayValues = valuesDisplayValues;
    } else {
      this.localService.showInformationByStatus(Status.DataRequired);
    }
  }

  onAddOrEdit(id = '') {
    const modalRef = this.modalService.open(ConfigSerialNumbersComponent);
    modalRef.componentInstance.id = id;
    modalRef.componentInstance.productId = this.productId;
    modalRef.componentInstance.purchaseEntryDetailId = this.purchaseEntryDetailId;
    modalRef.componentInstance.statuses = this.statuses;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.onLoad();
      }
    });
  }

  getSerialNumberStatus(id) {
    return this.statuses.find(x => x.key == id).value;
  }

  onAction(index, key = '') {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(BulkSerialNumbersComponent);
        modalRef.componentInstance.productId = this.productId;
        modalRef.componentInstance.purchaseEntryDetailId = this.purchaseEntryDetailId;
        modalRef.componentInstance.ctryCode = this.ctryCode;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onLoad();
          }
        });
      } break;
      case 2: {
        this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, key]);
      } break;
    }
  }
}
